module.exports = __webpack_public_path__ + "static/contigo2-bbd2c8858baa4c778235ad13176a8414.jpg";